import { DocumentType, IndividualRowsType } from "../../Types/documentsTypes";
import { timeStampToDocumentDate } from "../../utils/dateUtils";
import editIcon from "../../assets/images/edit-document-icon.svg";
import makePrimaryIcon from "../../assets/images/make-primary-document-icon.svg";

export const documemtSectionHeaders = {
  estimateSectionHeader: "Generate Estimate Documents",
  quoteSectionHeader: "Generate Quote Documents",
};

export const documentType = {
  estimate: "estimateContents",
  quote: "quoteContents",
};

export const documentStates = {
  primary: "Primary",
};

export const renameModalFields = {
  title: "Document Rename",
  okButtonLabel: "Save",
  content: "Rename",
  error: "Rename text shouldn't exceed 50 characters max",
  maxLimit: 50,
};

export const getDocumentRows = (
  data: DocumentType,
  type: string
): IndividualRowsType => {
  return data?.data?.[type]?.map?.((content) => {
    return {
      id: content?.id,
      name: content?.templateName,
      isPrimary: content?.isPrimary,
      date: timeStampToDocumentDate(content?.updatedAt),
    };
  });
};

export const editMenuLabels = {
  edit: "Edit",
  rename: "Rename",
  primary: "Make Primary",
};

export const editMenuItems = [
  {
    name: editMenuLabels.edit,
    icon: editIcon,
  },
  {
    name: editMenuLabels.rename,
    icon: editIcon,
  },
  {
    name: editMenuLabels.primary,
    icon: makePrimaryIcon,
  },
];

export const documentEditNotificationMessages = {
  renameSuccess: "Document renamed successfully!",
  renameFailure: "Failed to rename document!",
  makePrimarySuccess: "Document made primary successfully!",
  makePrimaryFailure: "Failed to make document primary!",
};

export const primaryDocType = {
  quote: "quote",
  estimate: "estimate",
};
